if (!customElements.get('sl-purchase-info')) {
  class SLPurchaseInfo extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.data = JSON.parse(this.querySelector('[data-sl-purchase-data]').textContent);
      this.form = this.closest('form');
      this.main = this.closest('.product-information');
      if (!this.form || !this.main) return;
      const opts = { signal: this.controller.signal };
      this.queue = () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.update()); };
      this.form.addEventListener('change', this.queue, opts);
      this.form.addEventListener('click', this.queue, opts);
      document.addEventListener('variant:update', this.queue, opts);
      this.observer = new MutationObserver(this.queue);
      this.observer.observe(this.form, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'checked', 'aria-checked'] });
      this.queue();
    }
    update() {
      const variant = this.data.variants.find(v => String(v.id) === this.form.querySelector('[name="id"]')?.value);
      if (!variant) return;
      const gummy = this.data.system ? variant.title.includes('Gummies') : this.data.gummy;
      const count = gummy ? 32 : 48;
      const flavor = gummy ? (variant.title.includes('Strawberry') ? 'strawberry' : 'berry') : 'mint';
      this.main.dataset.slFlavor = flavor;
      const title = this.main.querySelector('h1');
      const productTitle = this.data.system ? 'The System' : this.data.gummy ? `${variant.title} Energy Gummies` : 'Mint Energy Gum';
      if (title && title.textContent !== productTitle) title.textContent = productTitle;
      const selected = this.form.querySelector('.sls-option-container.sls-active');
      const once = selected?.querySelector('[data-type="one_time"]') || this.form.querySelector('.sls-option[data-type="one_time"]:checked');
      const id = this.form.querySelector('[name="selling_plan"]')?.value;
      const plan = once ? null : variant.plans.find(p => String(p.id) === String(id));
      const quantity = Number(this.form.querySelector('[name="quantity"]')?.value || 1);
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:this.data.currency}).format(cents / 100);
      const period = this.form.querySelector('.sls-select option:checked')?.textContent.trim();
      const price = (plan?.perDelivery ?? plan?.price ?? variant.price) * quantity;
      const labels = this.data.labels;
      const schedule = period ? `${labels.every} ${period}` : plan?.name.replace(/subscription/i, '').trim();
      const text = plan ? `${money(price)} ${schedule}` : `${money(price)} · ${labels.one_time}`;
      const terms = plan ? labels.subscription_terms.replace('[schedule]', schedule) : labels.once_terms;
      const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
      setText(this.querySelector('[data-sl-selected-price]'), text);
      setText(this.querySelector('[data-sl-selected-terms]'), terms);
      const add = this.form.querySelector('button[name="add"] .add-to-cart-text__content');
      if (add && !add.closest('button').disabled) setText(add, `${labels.add_to_cart} · ${money((plan?.price ?? variant.price) * quantity)}`);
      for (const option of this.form.querySelectorAll('.sls-option-container')) {
        let note = option.querySelector('.sl-seal-note');
        if (!note) { note = document.createElement('p'); note.className = 'sl-seal-note'; option.querySelector('.sls-label-container')?.append(note); }
        const isOnce = !!option.querySelector('[data-type="one_time"]');
        const p = variant.plans.find(p => String(p.id) === this.form.querySelector('.sls-select')?.value) || variant.plans[0];
        setText(note, isOnce ? labels.once_terms : p ? `${labels.only} ${Math.round(p.price / count)}¢ ${gummy ? labels.per_gummy : labels.per_piece}` : labels.choose_schedule);
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.observer?.disconnect(); cancelAnimationFrame(this.frame); }
  }
  customElements.define('sl-purchase-info', SLPurchaseInfo);
}
